import React from "react";

interface PracticeAreaCardProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  imageSrc?: string;
  className?: string;
}

const PracticeCard = ({
  title,
  description,
  icon,
  imageSrc,
  className = "",
}: PracticeAreaCardProps) => (
  <div
    className={`group border-2 hover:shadow-2xl border-legal-brown shadow-sm relative h-60 xl:h-72 overflow-hidden rounded-2xl ${className}`}
  >
    {/* Background Image */}
    <div
      className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
      style={{ backgroundImage: `url(${imageSrc})` }}
    />

    {/* Gradient Overlay - Darker at bottom */}
    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />

    {/* Title and Icon - Fixed at the bottom */}
    <div className="absolute inset-x-0 bottom-0 p-6">
      <div className="flex items-center gap-2">
        <div className="text-white/90">{icon}</div>
        <h3 className="text-xl tracking-wide font-marcellus font-semibold text-white">
          {title}
        </h3>
      </div>
    </div>

    {/* Description Section - Slides up on hover */}
    <div className="absolute space-y-3 inset-x-0 bottom-0 z-20 p-6 bg-gradient-to-r from-legal-bg-brown via-white to-legal-bg-brown transform transition-all duration-500 ease-out translate-y-full group-hover:translate-y-0">
      <div className="flex items-center gap-2">
        <div className="text-legal-dark-gray">{icon}</div>
        <h3 className="text-2xl font-semibold text-legal-dark-gray">{title}</h3>
      </div>
      <p className="text-legal-dark-gray tracking-tight font-marcellus text-base leading-relaxed">
        {description}
      </p>
    </div>
  </div>
);

export default PracticeCard;
